import {NumberInput, Paper, Select} from "@mantine/core";
import {BarChart} from "@mantine/charts";
import { WarningCircle as IconAlertTriangle } from "@phosphor-icons/react";
import {useMemo, useState} from "react";
import {Col, Row} from "../../components/Flex/Flex";
import Label from "../../components/Label/Label";
import {chanceArm, items} from './DoorDemolition';
import {hackTime} from "./Locks";
import {chartPalette} from "./chartUtils";
import {doors} from "./doorUtils";


const getAverageTime = (door, item, num, hw) => {

    let tta = 30 + (5 * (num - 1));
    let Fmod = item.firepower / (item.firepower + door.armour);
    let dAvg = Math.round((item.min+item.max)/2)*Fmod*num;
    let chanceA = chanceArm(num, hw);
    let roundAVG = Math.round(door.hull / (dAvg * (chanceA / 100)));
    let tpr = (4 + (tta/60));
    return Math.round(roundAVG * tpr);
}

const effectiveNums = [1,2,3,4,5,6];

const doorSeries = [
    {name: 'Slicing', color: chartPalette[0]},
    ...effectiveNums.map((n, i) => ({name: `Explosive (${n})`, color: chartPalette[i + 1]})),
];

export default function DoorCompare () {

    const [hw, setHW] = useState(0);
    const [crafting, setCrafting] = useState(0);
    const [co, setCO] = useState(0);
    const [itemID, setItemID] = useState(null);

    const item = useMemo(() => items.find(i => i.id === itemID), [itemID]);

    const chartDoor = useMemo(() => {
        if(!item) {
            return null;
        }

        return doors.map(d => {
            const row = {door: d.name, Slicing: hackTime(d, crafting, co)};
            effectiveNums.forEach(n => { row[`Explosive (${n})`] = getAverageTime(d, item, n, hw); });
            return row;
        });
    }, [crafting, co, hw, item]);

    return (
        <div>
            <title>Door Slicing vs Explosives</title>
            <h1>Slicing vs Explosives</h1>
            <Paper>
            <h2 className="mt-0 mb-0">AVG Hours to go through door <small>(Lower is better)</small></h2>
            <Row mb={2}>
                <Col>
                    <Label>Heavy Weapons</Label>
                    <NumberInput value={hw} onChange={setHW} min={0} max={5} style={{width: 80}}/>
                </Col>
                <Col>
                    <Label>Crafting</Label>
                    <NumberInput value={crafting} onChange={setCrafting} min={0} max={5} style={{width: 80}}/>
                </Col>
                <Col>
                    <Label>Computer Operations</Label>
                    <NumberInput value={co} onChange={setCO} min={0} max={5} style={{width: 80}}/>
                </Col>
                <Col>
                    <Label>Explosive</Label>
                    <Select value={itemID} onChange={setItemID} data={items.map(i => ({value: i.id, label: i.name}))}/>
                </Col>
            </Row>

            {item ? <BarChart h={350} data={chartDoor} series={doorSeries} dataKey="door" withLegend yAxisLabel="AVG Hours" /> : null}

            <p>For a more in-depth comparison use the "Locks" and "Door Demolition" tabs</p>
            <p><IconAlertTriangle size={16} /> Warning: Remember that using explosives can lead to backfires (the chances of that happening are not public), which may damage whoever is placing the explosive and any other character, droid or NPC present in the same room.<br />Explosives will also deal 2-5% damage to the entity hull, but will not take it lower than 10% of the max hull.</p>
        </Paper>
        </div>
    )

}



